import { Box, Typography, Stack, Paper } from "@mui/material";
import { useEffect, useState } from "react";
import { SunIcon, CloudIcon, RainIcon } from "../../components/icons/CustomIcons";
import { BrightCloudySkyIcon, SunnyCloudyIcon } from '../../assets/icons/weather/Icons'

const getWeatherIcon = (code) => {
    if (code === 0) return <SunnyCloudyIcon width={44} height={30} />;
    if ([1, 2, 3].includes(code)) return <CloudIcon size={40} />;
    if ([61, 63, 65].includes(code)) return <RainIcon size={40} />;
    return <CloudIcon size={40} />;
};

const parseWeather = (data) => {
    const now = new Intl.DateTimeFormat("en-IN", {
        timeZone: data?.timezone || "Asia/Qatar",
        timeStyle: "medium"
    }).format(new Date());

    return {
        temp: Math.round(data?.current?.temperature_2m),
        wind: Math.round(data?.current?.wind_speed_10m),
        humidity: data?.hourly?.relative_humidity_2m[0],
        rain: Math.round((data?.hourly?.precipitation[0] || 0) * 100),

        date: now.toLocaleString("en-IN", {
            day: "2-digit",
            month: "short",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit"
        }),

        daily: data?.daily?.time?.slice(0, 5)?.map((d, i) => ({
            day: new Date(d).toLocaleDateString("en-US", { weekday: "short" }),
            temp: Math.round(data?.daily?.temperature_2m_max[i]),
            code: data?.daily?.weathercode[i]
        }))
    };
};

const fetchWeather = async (location) => {
    if (!location) return
    try {
        let locStr = `latitude=${location?.lat}&longitude=${location?.lon}`
        const url = `https://api.open-meteo.com/v1/forecast?${locStr}&current=temperature_2m,wind_speed_10m&hourly=temperature_2m,relative_humidity_2m,precipitation,wind_speed_10m&daily=temperature_2m_max,weathercode`;
        const res = await fetch(url);
        return res.json();
    } catch (Err) {
        return {}
    }
};


export default function WeatherCard({ location,
    locationName = "West bay, Doha", height = "257px",
    bgIconColor = "#1976d2", iconWidth = '147px',
    headHeight = 120, py = 3, px = 3 }) {
    const [weather, setWeather] = useState(null);
    useEffect(() => {
        fetchWeather(location).then((data) => {
            let d = { ...data, country_name: location?.country_name, country_code: location?.country_code }
            setWeather(parseWeather(d));
        });
    }, [location]);

    if (!weather) return null;

    return (
        <Box className="rounded-lg" sx={{ py: py, px: px, height: height }}>
            <Stack spacing={2}>
                {/* Header */}
                <Stack direction="row" spacing={2} alignItems="center" sx={{ height: headHeight }}>
                    <Box sx={{
                        width: iconWidth, borderRadius: '16px',
                        textAlign: 'center', height: 1, backgroundColor: bgIconColor,
                        display: 'flex', justifyContent: 'center', alignItems: 'center'
                    }}>
                        {/* <SunIcon size={60} /> */}
                        <SunnyCloudyIcon />
                    </Box>
                    <Box sx={{ width: '50%' }}>
                        <Typography className="input-label" sx={{ mt: -1 }} fontSize={48} fontWeight={500}>
                            {weather.temp}°
                        </Typography>
                        <Typography sx={{ mt: -1, textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} className="input-label" fontSize={18} fontWeight={500}>
                            {locationName}
                        </Typography>
                        <Typography fontSize={12} sx={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }} className="input-label">
                            {weather.date}
                        </Typography>
                    </Box>
                </Stack>

                {/* Stats */}
                <Stack direction="row" justifyContent="space-between" >
                    <Typography className="input-label" fontSize={14}>Humidity: <span className="input-label" style={{ fontSize: 13, fontWeight: 700 }}>{weather.humidity}%</span></Typography>
                    <Typography className="input-label" fontSize={14}>Wind: <span className="input-label" style={{ fontSize: 13, fontWeight: 700 }}>{weather.wind}</span> km/h</Typography>
                    <Typography className="input-label" fontSize={14}>Rain: <span className="input-label" style={{ fontSize: 13, fontWeight: 700 }}>{weather.rain}</span>%</Typography>
                </Stack>

                {/* Forecast */}
                <Stack direction="row" spacing={1} justifyContent="space-between" sx={{ minWidth: 200, overflowX: 'auto' }}>
                    {weather?.daily?.map((d, i) => (
                        <Box
                            key={i}
                            sx={{
                                p: '6px',
                                textAlign: "center",
                                borderRadius: 3,
                                bgcolor: i === 1 ? "primary.main" : "#f5f5f5",
                                color: i === 1 ? "#fff" : "#000",
                                height: 88,
                                lineHeight: 0.5
                            }}
                        >
                            <Typography fontSize={12}>{d.day}</Typography>
                            {getWeatherIcon(d.code)}
                            <Typography fontWeight="bold">{d.temp}°</Typography>
                        </Box>
                    ))}
                </Stack>
            </Stack>
        </Box>
    );
}

